module.exports = __webpack_public_path__ + "static/media/20ECE22.c9507ca1.jpg";